import { createFileRoute } from "@tanstack/react-router";
import React from "react";

export const Route = createFileRoute("/$lang/circle/$circleId")({
  component: React.lazy(() =>
    import("@/pages/circle/CirclePage").then((mod) => ({
      default: mod.default,
    })),
  ),
});
